export const CO_SELL_DASHBOARD_PATH_LEGACY = '/legacy/co-sell';
export const CO_SELL_SETTINGS_PATH_LEGACY = '/settings/account/legacy-co-sell';
